import { render, staticRenderFns } from "./DesktopContent.vue?vue&type=template&id=49031835&scoped=true&"
import script from "./DesktopContent.vue?vue&type=script&lang=ts&"
export * from "./DesktopContent.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopContent.vue?vue&type=style&index=0&id=49031835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49031835",
  null
  
)

export default component.exports